import { render, staticRenderFns } from "./attribute_value_add.vue?vue&type=template&id=6f8d4259&scoped=true"
import script from "./attribute_value_add.vue?vue&type=script&lang=js"
export * from "./attribute_value_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d4259",
  null
  
)

export default component.exports